import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { ChevronLeft as ChevronLeftBase, GetApp as GetAppBase, LocationOn as LocationOnBase } from '@mui/icons-material'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const GridContainer = styled(({ height, margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const LocationIcon = styled(LocationOnBase)``

export const Info = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: right;
`

export const Link = styled('span')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  &:hover {
    text-decoration-line: underline;
  }
`

export const Return = styled('div')`
  align-items: center;
  display: inline-flex;
  margin: 5px 0 0;

  &:hover span {
    text-decoration-line: underline;
  }
`

export const ReturnText = styled('span')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  user-select: none;
`

export const ReturnIcon = styled(ChevronLeftBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.primary};
    user-select: none;
  }
`

export const Ranking = styled('div')`
  align-items: center;
  background-color: transparent;
  color: ${props => props.theme.palette.brand.black1};
  display: flex;
  height: 32px;
  justify-content: center;
  margin: 0;
  max-width: 52px;
  width: 100%;

  &::after {
    content: '. º';
  }
`

export const Podium = styled(Ranking)`
  background-color: ${props => props.theme.palette.blue[90]};
  border-radius: 4px;
  color: ${props => props.theme.palette.brand.primary};

  &::after {
    color: ${props => props.theme.palette.brand.primary};
    content: '. º';
  }
`

export const BubblesTitle = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  margin: 0;
`

export const BubblesLabel = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 300;
  line-height: 16px;
  margin: 0;
`

export const BubblesValue = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  margin: 0;
`

export const BubblesDetail = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  margin: 0;
`

export const BubblesList = styled('ul')`
  box-sizing: border-box;
  margin: 10px 0 0 10px;
  padding: 0 0 0 10px;
`

export const BubblesItem = styled('li')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 10px;
  font-weight: 300;
  line-height: 12px;
  margin: 0 0 10px;
  max-width: 195px;

  &:last-of-type {
    margin: 0;
  }
`

export const DownloadDetails = styled('div')`
  align-items: center;
  cursor: pointer;
  display: inline-flex;

  &:hover span {
    text-decoration: underline;
  }
`

export const DownloadDetailsCircle = styled('div')`
  align-items: center;
  border: 1px solid ${props => props.theme.palette.brand.black3};
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin: 0 6px 0 0;
  user-select: none;
`

export const DownloadDetailsIcon = styled(({ open, ...props }) => <GetAppBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black3};
    font-size: 1.2rem;
    height: 14px;
    padding: 2px;
    user-select: none;
    width: 14px;
  }
`

export const DownloadDetailsText = styled('span')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  user-select: none;
`

export const Strong = styled('strong')``
